/*
  HM Atlas Frontend
  AI utility functions.
*/

import * as entityUtils from '@/core/utils/entityUtils';

/* ---------------------------------------------------------- */

/**
 * Construct the data to be sent to the API to ask a question about Field Calculation formula.
 * @param {string} queryType  Type of question to ask the Assistant.
 * @param {string} question The raw question to be asked.
 * @param {*} targetField Definition for the calculated field.
 * @param {array} queryFields List of fields definitions for the target table available to be used in the formula.
 * @returns data object to be sent to API to ask question.
 */
export const constructFieldCalculationAssistantQueryData = ({ queryType, question, targetField, queryFields, functions, currentFormula, formulaError }) => {
  // Data structure expected by the API.
  const data =
  {
    queryType: queryType,
    question: question,
    dataType: entityUtils.getFieldDataType(targetField),
    fields: queryFields.map(field => `'${field.displayName}' (${entityUtils.getFieldDataType(field)})`),
  };
  if (Array.isArray(functions)) data.functions = functions;
  if (currentFormula) data.currentFormula = currentFormula;
  if (formulaError) data.formulaError = formulaError;
  return data;
};

/* ---------------------------------------------------------- */
